// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hb","advertCardNum":"c-a_hc"};